export default __webpack_public_path__ + "static/media/zakochajSiewWarszawie.58dd97b5.jpg";